import axios from "axios";

/**
 * The office stamp registered in HRMS for an admin unit and a service, the
 * same API the discipline system uses (there with service_name "pdms").
 * Change STAMP_SERVICE_NAME if HRMS registers prosecution under another name.
 */
export const STAMP_SERVICE_NAME = "pcms";

const hrmsBase = () => {
  const base = process.env.REACT_APP_API_BASE_URL_2 || "";
  return base.endsWith("/") ? base : `${base}/`;
};

export const fetchOfficeStamp = async (adminUnit: string): Promise<File> => {
  const response = await axios.get<Blob>(
    `${hrmsBase()}organization/service-stamp/read_stamp/`,
    {
      params: { admin_unit_uuid: adminUnit, service_name: STAMP_SERVICE_NAME },
      responseType: "blob",
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem("authToken")}`,
      },
    },
  );
  const blob = response.data;
  if (!blob?.size || !blob.type.startsWith("image/")) {
    throw new Error("No stamp image is registered for this office.");
  }
  const extension = blob.type.split("/")[1]?.replace("jpeg", "jpg") || "png";
  return new File([blob], `office_stamp.${extension}`, { type: blob.type });
};
